const DEV_HINTS = [
  'npm run',
  'php:serve',
  'db_config',
  'mysql',
  'migrate_',
  'invalid json',
  'catalog api',
  'http 404',
  'http 503',
];

function looksLikeDevMessage(raw) {
  const lower = String(raw || '').toLowerCase();
  return DEV_HINTS.some((hint) => lower.includes(hint));
}

/** Strip operator/dev strings before showing catalog errors to shoppers. */
export function customerCatalogErrorMessage(raw, fallback = 'We could not load the shop right now. Please refresh or try again.') {
  if (!raw || looksLikeDevMessage(raw)) return fallback;
  return String(raw);
}

/** Strip operator/dev strings from API error payloads shown on storefront pages. */
export function customerApiErrorMessage(raw, fallback = 'Something went wrong. Please try again.') {
  if (!raw || looksLikeDevMessage(raw)) return fallback;
  return String(raw);
}
